import { createStore } from 'vuex';
import axios from 'axios';

const toRoleValue = value => {
    if (typeof value === 'string') return value.trim();
    if (value && typeof value === 'object') {
        return String(value.authority || value.role || '').trim();
    }
    return '';
};

const normalizeAuthorities = authorities => {
    if (!Array.isArray(authorities)) return [];
    const unique = new Set();
    authorities.forEach(item => {
        const role = toRoleValue(item);
        if (role) unique.add(role);
    });
    return [...unique];
};

export default createStore({
    state: {
        user: null,
        isAuthenticated: false,
        loading: true,
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
            state.isAuthenticated = true;
            state.loading = false;
        },
        clearUser(state) {
            state.user = null;
            state.isAuthenticated = false;
            state.loading = false;
        },
        setLoading(state, value) {
            state.loading = value;
        },
    },
    actions: {
        async fetchCurrentUser({ commit }) {
            commit('setLoading', true);
            try {
                const response = await axios.get('/api/account/me');
                console.log("Response from /api/me:", response.data);
                const data = response.data;
                if (data.authenticated) {
                    const authorities = normalizeAuthorities(data.authorities);
                    commit('setUser', {
                        username: data.username,
                        authorities,
                        roles: authorities,
                    });
                } else {
                    commit('clearUser');
                }
            } catch (error) {
                console.error('Ошибка при получении данных пользователя:', error);
                commit('clearUser');
            }
        },
    },
    getters: {
        isAuthenticated: state => state.isAuthenticated,
        currentUser: state => state.user,
        userRoles: state => {
            const roles = state.user?.roles || state.user?.authorities;
            return normalizeAuthorities(roles);
        },
        hasRole: (state, getters) => role => getters.userRoles.includes(String(role || '').trim()),
        isAdmin: (state, getters) => getters.userRoles.includes('ROLE_ADMIN'),
        loading: state => state.loading,
    },
});
